import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useDeleteLettersOfMedicalNecessityQuery = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (id?: string) => api.delete(API_URL.LETTERS_OF_MEDICAL_NECESSITY_BY_ID(id || '')),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.LETTERS_OF_MEDICAL_NECESSITY],
        });
      },
    }
  );
  return {
    isLoading,
    handleDelete: mutateAsync,
  };
};

export default useDeleteLettersOfMedicalNecessityQuery;
